import { render, staticRenderFns } from "./NonCompliantProductSearchTableComponent.vue?vue&type=template&id=4dd9d53c"
import script from "./NonCompliantProductSearchTableComponent.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductSearchTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports